import type {
  DocumentKind,
  RiskSignal,
  RiskSignalGroupKind,
  SignalSeverity,
} from '@onefootprint/request-types/dashboard';

type RiskSignalSection = {
  key: string;
  group: RiskSignalGroupKind;
  documentKind?: DocumentKind;
  signals: RiskSignal[];
};

const SEVERITY_ORDER: SignalSeverity[] = ['high', 'medium', 'low', 'info'];

const bySeverity = (a: RiskSignal, b: RiskSignal) =>
  SEVERITY_ORDER.indexOf(a.severity) - SEVERITY_ORDER.indexOf(b.severity);

// Groups risk signals by group, most severe first, and the sections by their worst signal. `doc` splits further by
// document: a playbook may collect several, and all of their signals share the one group.
const groupRiskSignals = (riskSignals: RiskSignal[]): RiskSignalSection[] => {
  const sections = new Map<string, RiskSignalSection>();

  riskSignals.forEach(signal => {
    const key = `${signal.group}:${signal.documentKind ?? ''}`;
    let section = sections.get(key);
    if (!section) {
      section = { key, group: signal.group, documentKind: signal.documentKind, signals: [] };
      sections.set(key, section);
    }
    section.signals.push(signal);
  });

  const result = Array.from(sections.values());
  result.forEach(({ signals }) => {
    signals.sort(bySeverity);
  });
  return result.sort((a, b) => bySeverity(a.signals[0], b.signals[0]));
};

export type { RiskSignalSection };
export default groupRiskSignals;
